import { HttpService } from 'src/app/services/http-wrapper.service';
import { ErrorMessageComponent } from 'src/app/shared/error-message/error-message.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UtilService } from 'src/app/util.service';

@Component({
  selector: 'app-all-forms',
  templateUrl: './all-forms.component.html',
  styleUrls: ['./all-forms.component.css']
})
export class AllFormsComponent implements OnInit {
  @ViewChild(ErrorMessageComponent)

  public errorComponent!: ErrorMessageComponent;
  constructor(public httpService : HttpService,public utilService: UtilService) { }
  allFormsData:any;
  
  ngOnInit(): void {
    this.httpService.startCallGroup(1,"All Forms");
      this.loadConfiguration();
  }
  
  loadConfiguration() {
    this.httpService.get("assets/forms.json", this.errorComponent)
      .subscribe((dummyData) => {
        this.allFormsData = dummyData;
      });
  }
}
